import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { of, switchMap } from 'rxjs';

export const NoAuthGuard: CanActivateFn | CanActivateChildFn = (route, state) =>
{
    const authService: AuthService = inject(AuthService)
    const router: Router = inject(Router);

    // Check the authentication status
    return inject(AuthService).check().pipe(
        switchMap((authenticated) =>
        {
            // Redirect to reset page if there is a reset token in url
            if (route.queryParams?.token)
            {
                const url = state.url;
                if (url.includes('/reset')) {
                    // If the user is authenticated, sign out and redirect to reset password
                    if (authenticated) {
                        sessionStorage.removeItem('accessToken')
                        authService._authenticated = false;
                        return of(true);
                    }
                    else {
                        return of(true);
                    }
                }
            }

            // If the user is authenticated...
            if ( authenticated )
            {
                // Allow authenticated users to access sales agent route (pre-orders)
                if (state.url.includes('/pre-orders')) {
                    return of(true);
                }
                return of(router.parseUrl(''));
            }

            // Allow the access
            return of(true);
        }),
    );
};
